/**
 * Alpine x directive utility for improving FormBuilder responsive actions
 */

const initializeForm = function(formBuilderForm, mediaQuery) {

  /**
   * Sets the style of columns based on persisted values in data attributes
   */
  const setColumnWidth = inputfield => {
      if (!inputfield.hasAttribute('data-original-width')) {
        return;
      }

      inputfield.style.flexBasis = matchMedia(mediaQuery).matches ? `${inputfield.dataset.originalWidth - 5}%` : '';
      inputfield.style.width = '';
  }

  /**
   * Observer that sets style attribute values when FormBuilder adds width data attributes to .Inputfield elements
   */
  const inputfieldObserver = new MutationObserver((mutations, observer) => {
    mutations.forEach(mutation => {
      const inputfield = mutation.target;

      const mutationAttribute = mutation.attributeName;

      if (mutationAttribute !== 'data-original-width' || mutationAttribute === 'style') {
        return;
      }

      setColumnWidth(inputfield)

      // Prevent FormBuilder JS from attempting to re-parse the column width on a resize event
      inputfield.classList.remove('InputfieldColumnWidth', 'InputfieldColumnWidthFirst');
    });
  });

  if (!formBuilderForm) {
    return;
  }

  // ALl inputfields in the current form
  let inputfields = formBuilderForm.querySelectorAll('.Inputfield');

  /**
   * Prevent ProcessWire inputfields.js from attempting to match heights
   */
  formBuilderForm.classList.add('InputfieldFormNoHeights');

  /**
   * Executes resize on all inputfields
   */
  const setColumnWidths = () => {
    [...inputfields].forEach(inputfield => setColumnWidth(inputfield));
  }

  // Debounced resize function
  const resizeInputs = Alpine.debounce(() => setColumnWidths(), 250);

  let resizeListener = window.addEventListener('resize', () => {
    resizeInputs()
  });

  // Initialize observers on each inputfield
  [...inputfields].forEach(el => {
    inputfieldObserver.observe(el, { attributes: true });
  });

  // Initialize column width
  setColumnWidths();

  return {
    resizeListener: resizeListener,
  }
};

/**
 * x-formbuilder:responsive
 */
const ResponsiveFormBuilder = function(el, { value, modifiers, expression }, { Alpine }) {
  /**
   * Set the mediaQuery rule to either the value passed or the default value
   */
  const mediaQuery = expression || '(min-width: 1024px)';

  let formBuilderForm = el.querySelector('form.FormBuilder');
  // let formBuilderForm = el.querySelector('.InputfieldForm');

  // Initial on load
  let resizeListener = initializeForm(formBuilderForm, mediaQuery).resizeListener;

  /**
   * Observer for all child elements of the x-directive element, reinitializes observer on new
   * FormBuilder form added via AJAX
   */
  const domUpdateObserver = new MutationObserver((mutations, observer) => {
    mutations.forEach(mutation => {
      if (
        !mutation.addedNodes.length ||
        mutation.addedNodes.length > 1 ||
        mutation.addedNodes[0].nodeName !== 'FORM'
      ) {
        return;
      }

      const formElement = mutation.addedNodes[0];

      if (!formElement.classList.contains('FormBuilder')) {
        return;
      }

      window.removeEventListener('resize', resizeListener);

      resizeListener = initializeForm(formElement, mediaQuery).resizeListener;
    });
  });

  domUpdateObserver.observe(el, {childList: true, subtree: true});
}

export default ResponsiveFormBuilder;
